export const PAYMENT_STATUS = {
  IDLE: 'IDLE',
  STARTED: 'STARTED',
  ENDED_SUCCESS: 'ENDED_SUCCESS',
  ENDED_FAILED: 'ENDED_FAILED',
};

export const PAYMENT_KIT_ERROR_TYPES = {
  PAYMENT_FAILED: 'PAYMENT_FAILED',
};

export const INTERNAL_TESTING_SERVICE_TYPE = 'INTERNAL_TESTING';
export const ENTERPRISE_BALANCE_SERVICE_TYPE = 'ENTERPRISE_BALANCE';
export const ENTERPRISE_LIMIT_SERVICE_TYPE = 'ENTERPRISE_LIMIT';
export const ENTERPRISE_GC_SERVICE_TYPE = 'ENTERPRISE_GC';
export const ENG_LANG_CODE = 'en';
